import React, { useEffect, useState, Fragment } from 'react';
import { Table } from 'reactstrap';
import './tableContainer.css';
import moment from "moment";


function TableContainer(props) {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [limitLoad, setLimitLoad] = useState(0);
  function sortBy(filterCol) {
    // filterObj holds the obj we are filtering by
    let filterObj = filterCol || false;
    // new columns hook to setColumns at the end
    let newColumn = (columns.length > 0 ? columns : props.columns);
    if (filterObj) {
      newColumn.map((obj) => {
        if (obj.accessor === filterObj.accessor) {
          // Filter ranges from -1-1
          // -1 is being used in descending order
          // 0 is not being used
          // 1 is being used in ascending order
          // we use mod to reset back to 0 so there is no filter
          obj.filter = (obj.filter + 1);
          if (obj.filter === 2) {
            obj.filter = -1;
          }
          if (obj.filter === 0) {
            obj.filter = 1
          }
        } else {
          obj.filter = 0;
        }
      })
      filterObj = false;
    }

    // check for filter
    newColumn.map((obj) => {
      if (obj.filter !== 0) {
        filterObj = obj;
      }
    });
    //if not filter then fom is descending
    if (!filterObj) {
      newColumn[2].filter = -1;
      filterObj = newColumn[2]
    }

    // if default sort
    if (filterObj.accessor === "fom" && filterObj.filter === -1) {
      setData([...props.data]);
      setColumns([...newColumn]);
      return
    }
    // sort
    let newData = [...props.data]
    newData.sort((a, b) => {
      if (filterObj.accessor === 'comment') {
        if (a['comment'].toUpperCase() < b['comment'].toUpperCase()) {
          return (-1 * filterObj.filter); // if descending it is -1 which will give 1 instead
        } else if (a['comment'].toUpperCase() > b['comment'].toUpperCase()) {
          return (1 * filterObj.filter);
        } else {
          return 0;
        }
      } else if (filterObj.accessor === 'time') {
        let dataA = new Date(a['time']);
        let dataB = new Date(b['time'])
        if (dataA < dataB) {
          return (-1 * filterObj.filter); // if descending it is -1 which will give 1 instead
        } else if (dataA > dataB) {
          return (1 * filterObj.filter);
        } else {
          return 0;
        }
      } else if (filterObj.accessor === 'fom') {
        if (a['fom'] < b['fom']) {
          return (-1 * filterObj.filter); // if descending it is -1 which will give 1 instead
        } else if (a['fom'] > b['fom']) {
          return (1 * filterObj.filter);
        } else {
          return 0;
        }
      }
      return 0;
    })
    setData([...newData]);
    setColumns([...newColumn]);
    return
  }

  useEffect(() => {
    let element = document.getElementById('table-content');
    element.scrollTop = 0;
    setLimitLoad(props.data.length > 100 ? 100 : props.data.length);
    sortBy();
  }, [props.data]);

  const handleScroll = (event) => {
    if (data.length === limitLoad) {
      return;
    }
    let target = event.target

    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
      setLimitLoad(data.length);
    }
  };

  function tableContent() {
    let loadTable = [];
    for (let i = 0; i < limitLoad; i++) {
      loadTable.push(<Fragment>
        <tr className={((new Date(data[i].time) > props.dateObj.date && new Date(data[i].time) < moment(props.dateObj.date).add(props.dateObj.duration, props.dateObj.units)) ? 'slectedTime' : '') + ' sitl-item'} onClick={() => {
          props.setClanderToDate(data[i].time);
        }}>
          <td>{data[i].comment}</td>
          <td className='table-time'>
            {data[i].time}
          </td>
          <td >
            {data[i].fom}
          </td>
        </tr>
      </Fragment>)
    }
    return loadTable;
  }
  return (
    <Fragment>
      <div className='table-container' id="table-content" onScroll={handleScroll}>
        <Table className='fixed-header'>
          <thead className='header'>
            <tr>
              {columns.map((column) => {
                return (
                  <th onClick={() => {
                    sortBy(column);
                  }}>
                    <div className='sitl-header'>
                      {column.Header}
                      <svg className={`arrow-direction-${column.filter} sort-arrows`} focusable="false" aria-hidden="true" viewBox="0 0 24 24">
                        <path d="M7 10l5 5 5-5z"></path></svg></div>
                  </th>
                )
              })}
            </tr>
          </thead>

          <tbody className='table-body'>
            {data.length === 0 ? '' : tableContent()}
            {data.length === limitLoad ? '' :
              <div><center> Loading Table... </center></div>}
          </tbody>
        </Table>
      </div>
    </Fragment>
  )
}

export default TableContainer;